import { Branding, BrandingDisabledIf, DisabledPrompt, useModel } from "bcms-react";
import { MainNavItem, MainNavMenuItem } from "../..";
import "./styles.css";

/**
 * @name BID126MainNavItems
 * @function
 * @extends React.Component
 * @exported true
 * @description The main component for navigation for BID 1224.
 * @example
 * export default function Component() {
 *  return (
 *      <div>
 *          <BID1224MainNavView/>
 *      </div>
 *  );
 * }
 */
export default function BID126MainNavItems(props) {
    const { branding, demos } = useModel();
    const { options } = branding;

    const externalTransfersLink = options.tn19_courseID_abi22 === null ? <DisabledPrompt><MainNavMenuItem label="External Transfers"  data-point="Nav_External_Transfers" /></DisabledPrompt> : <MainNavMenuItem label="External Transfers" route="/externalTransfers" data-point="Nav_External_Transfers" />;
                               
    const newAccountsLink =  <MainNavItem label="Accounts" data-point="Nav_Accounts" activeRoutes={["/accountSummary", "/stopPayment", "/download"]}>
                                <MainNavMenuItem label="Account Summary" route="/accountSummary" data-point="Nav_Account_Summary" />
                                <DisabledPrompt>
                                    <MainNavMenuItem label="Order Checks" data-point="Nav_Order_Checks" />
                                </DisabledPrompt>
                                <DisabledPrompt>
                                    <MainNavMenuItem label="Credit Cards" data-point="Nav_Credit_Cards" />
                                </DisabledPrompt>
                                <MainNavMenuItem label="Stop Payment" route="/stopPayment" data-point="Nav_Stop_Payments" />
                                <MainNavMenuItem className="download-transaction-history-link" label="Quicken/Quickbooks" route="/download" data-point="Nav_Download" />
                            </MainNavItem>;

    const paymentLink = <MainNavItem label="Payments" data-point="Nav_Payments" activeRoutes={[ "/zelle/RXP17/paymentCenter", "/bid-126-transfers", "/bid-126-external-transfers" ]}>
        <MainNavMenuItem label="Pay Bills" route="/payments" data-point="Nav_Pay_Bills" />
        <MainNavMenuItem label="Pay my Loan" data-point="Nav_Payments">
            <MainNavMenuItem label="From my Park Account" route="/bid-126-transfers" data-point="Nav_Transfers" />
            <MainNavMenuItem label="From another Bank" route="/bid-126-external-transfers" data-point="Nav_Transfer_External_Accounts" />
        </MainNavMenuItem>
        <MainNavMenuItem label="Pay People with Zelle" route="/zelle" data-point="Nav_Zelle" />
    </MainNavItem>;

    const statementsLink = <MainNavItem label="Statements" data-point="Nav_Statements" activeRoutes={["/statements", "/statementPreference" ]}>
        <MainNavMenuItem label="View Statements" route="/statements" data-point="Nav_eStatements_Notices" />
        <MainNavMenuItem label="Go Paperless" route="/statementPreference" data-point="Nav_ePeference" />
    </MainNavItem>;

    const tools = <MainNavItem label="Tools" data-point="Nav_Tools" activeRoutes={[ "/creditScore", "/myFinances" ]}>
        <MainNavMenuItem label="Credit Sense" route="/creditScore" data-point="Nav_eStatements_Notices" />
        <MainNavMenuItem label="Financial Manager" route="/myFinances" data-point="Nav_My_Finances" />
    </MainNavItem>;

    const cardsLink = <BrandingDisabledIf id="chw23_courseid_abi22" exp={ value => value !== null && value !== undefined }>
                        <MainNavItem label="Debit Cards" route="/chw23" data-point="Nav_Cards"/>
                    </BrandingDisabledIf>;

    const alertsLink = <MainNavItem label="Alerts" data-point="Nav_Manage_Alerts">
        <DisabledPrompt>
            <MainNavMenuItem label="Account Activity" data-point="Nav_Account_Activity" />
        </DisabledPrompt>
        <DisabledPrompt>
            <MainNavMenuItem label="Debit Card and Message" data-point="Nav_Debit_Card_And_Message" />
        </DisabledPrompt>
    </MainNavItem>;

    const moreLink = <MainNavItem label="More" data-point="Nav_More">
        <DisabledPrompt>
            <MainNavMenuItem label="Open an Account" data-point="Nav_Open_Account" />
        </DisabledPrompt>
        <DisabledPrompt>
            <MainNavMenuItem label="Apply for a Home Loan" data-point="Nav_Apply_For_A_Home_Loan" />
        </DisabledPrompt>
        <DisabledPrompt>
            <MainNavMenuItem label="Book an Appointment" data-point="Nav_Book_An_Appointment" />
        </DisabledPrompt>
        <DisabledPrompt>
            <MainNavMenuItem label="Get ParkDirect" data-point="Nav_Get_ParkDirect" />
        </DisabledPrompt>
    </MainNavItem>;

    const newTransfersLink = <MainNavItem label="Transfers" data-point="Nav_Transfers" activeRoutes={[ "/transfers", "/externalTransfers", "/transferActivity/scheduledTransfers", "/unlinkedTransferAccounts" ]} >
                                <MainNavMenuItem label="Make a Transfer" data-point="Nav_Make_Transfer">
                                    <MainNavMenuItem label="My Accounts" route="/transfers" data-point="Nav_My_Accounts"/>
                                    <MainNavMenuItem label="Bank to Bank" route="/externalTransfers" data-point="Nav_External_Transfers"/>
                                </MainNavMenuItem>
                                <MainNavMenuItem label="Set up & manage transfers" data-point="Nav_Make_Transfer">
                                    <MainNavMenuItem label="Scheduled Transfers" route="/transferActivity/scheduledTransfers" data-point="Nav_Transfer_Activity"/>
                                    <MainNavMenuItem label="Transfer History" route="/transferActivity/scheduledTransfers" data-point="Nav_Transfer_History"/>
                                    <MainNavMenuItem label="Set up Bank to Bank" route="/externalTransfers" data-point="Nav_Set_Up_Bank_To_Bank"/>
                                    <MainNavMenuItem label="Set up Park Transfer" route="/unlinkedTransferAccounts" data-point="Nav_Transfer_Accounts"/>
                                </MainNavMenuItem>
                            </MainNavItem>;
                            
    const pfmLink = options.pfm21_courseID_abi22 === null
    ? <DisabledPrompt><MainNavItem label="My Finances" data-point="Nav_My_Finances"/></DisabledPrompt> 
    : <MainNavItem label="My Finances" route="/myFinances" data-point="Nav_My_Finances"/>;

    // END: Branded links declared here and returned in the component.

    return (
        <Branding id="bid_abi22" value="126">
            <div className="flex-container flex-horizontal bid-126-menu">
                { newAccountsLink }
                { paymentLink }
                { newTransfersLink }
                { statementsLink }
                { tools }
                { cardsLink }
                { alertsLink } 
                { moreLink }    
            </div>
        </Branding>
    );
}
